import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
export var Conversation = /*#__PURE__*/function (_Entity) {
  _inherits(Conversation, _Entity);

  var _super = _createSuper(Conversation);

  function Conversation() {
    _classCallCheck(this, Conversation);

    return _super.apply(this, arguments);
  }

  _createClass(Conversation, [{
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }, {
    key: "context",
    get: function get() {
      return this.props.context;
    }
  }, {
    key: "skillId",
    get: function get() {
      return this.props.skillId;
    }
  }, {
    key: "resourceId",
    get: function get() {
      return this.props.resourceId;
    }
  }, {
    key: "resourceType",
    get: function get() {
      return this.props.resourceType;
    }
  }, {
    key: "tags",
    get: function get() {
      return this.props.tags;
    }
  }, {
    key: "files",
    get: function get() {
      return this.props.files;
    }
  }, {
    key: "messageCount",
    get: function get() {
      return this.props.messageCount;
    }
  }, {
    key: "totalCost",
    get: function get() {
      return this.props.totalCost;
    }
  }, {
    key: "totalTokenUsed",
    get: function get() {
      return this.props.totalTokenUsed;
    }
  }, {
    key: "lastMessageAt",
    get: function get() {
      return this.props.lastMessageAt;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.title,
        argumentName: 'Title'
      }, {
        argument: props.skillId,
        argumentName: 'SkillId'
      }, {
        argument: props.resourceId,
        argumentName: 'ResourceId'
      }, {
        argument: props.resourceType,
        argumentName: 'ResourceType'
      }, {
        argument: props.messageCount,
        argumentName: 'MessageCount'
      }, {
        argument: props.totalCost,
        argumentName: 'TotalCost'
      }, {
        argument: props.totalTokenUsed,
        argumentName: 'TotalTokenUsed'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Invalid conversation props');
      }

      var conversation = new Conversation(props, new UniqueEntityID(props.id));
      return Result.ok(conversation);
    }
  }]);

  return Conversation;
}(Entity);